/*eslint no-magic-numbers: ["error", { "ignore": [0,1,2] }]*/
import React from 'react'
import { FormattedMessage } from 'react-intl'

import capitalizeString from 'utils/capitalize'

import ArrowRight24 from 'assets/icons/arrow-right_24px'

import {
  ViewActionStyle
} from './style'
import { formatDateYear } from 'utils/formatDateYear'
import { SITE_STATUS_EDIT_ONLY_ID, SITE_STATUS_SUBMITTED_EDIT_ONLY_ID } from 'constants/siteStatuses'

export const makeSitesRows = (sites = []) => {

  return sites
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
    .map((site) => {
      const formattedDate = formatDateYear(site.createdAt);
      const time = site.createdAt
        ? new Date(site.createdAt).toLocaleTimeString([], { hour12: true })
        : new Date().toLocaleTimeString([], { hour12: true });
      const editOnlySiteStatus = site.SiteStatusId === SITE_STATUS_EDIT_ONLY_ID || site.SiteStatusId === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID

      return {
        proposer: `${capitalizeString(site.User.lastName)} ${capitalizeString(
          site.User.firstName
        )}`,
        date: formattedDate,
        time,
        actions: (
          <ViewActionStyle>
            <p>View</p>
            <ArrowRight24 />
          </ViewActionStyle>
        ),
        id: site.id,
        historyId: editOnlySiteStatus ? site.sitehistoryId : site.historyId,
        siteStatusId: site.SiteStatusId
      };
    });
}


export const makeSitesColumns = () => {
  return [
    {
      id: 'proposer',
      header: (
        <>
          <FormattedMessage id='proposer' />
        </>
      ),
      accessorKey: 'proposer',
      style: {
        width: '27%'
      },
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'date',
      header: (
        <>
          <FormattedMessage id='date' />
        </>
      ),
      accessorKey: 'date',
      style: {
        width: '23%'
      },
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'time',
      header: (
        <>
          <FormattedMessage id='time' />
        </>
      ),
      accessorKey: 'time',
      style: {
        width: '13%'
      },
      cell: ({ getValue }) => getValue()
    },
    {
      id: 'actions',
      header: <FormattedMessage id='actions' />,
      accessorKey: 'actions',
      style: {
        width: '15%'
      },
      cell: ({ getValue }) => getValue()
    }
  ]
}